export const selectPreviousLeagueSeason = (currentSeason, seasons) => {
  const currentStart = new Date(currentSeason?.starting_at || 0).getTime();
  if (
    !Number.isFinite(Number(currentSeason?.league_id)) ||
    !Number.isFinite(currentStart)
  )
    return null;
  return (
    (Array.isArray(seasons) ? seasons : [])
      .filter(
        (season) =>
          Number(season?.league_id) === Number(currentSeason.league_id) &&
          Number(season?.id) !== Number(currentSeason.id) &&
          new Date(season?.starting_at || 0).getTime() < currentStart
      )
      .sort(
        (a, b) =>
          new Date(b?.starting_at || 0).getTime() -
          new Date(a?.starting_at || 0).getTime()
      )[0] || null
  );
};
